import React from "react"
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom"
import { IntlProvider } from "react-intl"
import { RedirectWithLogging } from "./pages/RedirectWithLogging/RedirectWithLogging"
import MainFrame from "./layouts/MainFrame"
import Home from "./pages/Home/Home"
import ServiceDescription from "./pages/AbTest/ServiceDescription"
import Pricing from "./pages/Pricing/Pricing"
import Funnel from "./pages/Funnel/Funnel"
import FeatureFlag from "./pages/FeatureFlag/FeatureFlag"
import { LangCode, Locale } from "./locale"
import Meta from "./Meta"
import { Helmet } from "react-helmet"
import NotFound from "./pages/Error/NotFound"
import Analytics from "./pages/Analytics/Analytics"

const { lang: locale, message: messages } = Locale.getDefault()

const Routes = () => (
  <Router>
    <Switch>
      <Route path="/redirect" component={RedirectWithLogging} />
      <Route path="/" exact>
        <Redirect to={locale + "/"} />
      </Route>
      <Route
        path={"/:locale(en|ko)"}
        render={({ match, location }) => {
          const lang = match.params.locale
          if (lang != locale) {
            Locale.changeLangAndReload(lang as LangCode)
            return null
          }
          return (
            <MainFrame>
              <Switch>
                <Route path={`${match.path}/`} exact>
                  <>
                    <Helmet>
                      <link rel="canonical" href={`https://hackle.io/${lang}/`} />
                      <link rel="alternate" href="https://hackle.io/ko/" hrefLang="ko" />
                      <link rel="alternate" href="https://hackle.io/en/" hrefLang="en" />
                      <link rel="alternate" href="https://hackle.io/en/" hrefLang="x-default" />
                    </Helmet>
                    <Home />
                  </>
                </Route>
                <Route path={`${match.path}/service/funnel`} exact>
                  <>
                    <Helmet>
                      <link rel="canonical" href={`https://hackle.io/${lang}/service/funnel`} />
                      <link rel="alternate" href="https://hackle.io/ko/service/funnel" hrefLang="ko" />
                      <link rel="alternate" href="https://hackle.io/en/service/funnel" hrefLang="en" />
                      <link rel="alternate" href="https://hackle.io/en/service/funnel" hrefLang="x-default" />
                    </Helmet>
                    <Funnel />
                  </>
                </Route>
                <Route path={`${match.path}/service`} exact>
                  <>
                    <Helmet>
                      <link rel="canonical" href={`https://hackle.io/${lang}/service`} />
                      <link rel="alternate" href="https://hackle.io/ko/service" hrefLang="ko" />
                      <link rel="alternate" href="https://hackle.io/en/service" hrefLang="en" />
                      <link rel="alternate" href="https://hackle.io/en/service" hrefLang="x-default" />
                    </Helmet>
                    <ServiceDescription />
                  </>
                </Route>
                <Route path={`${match.path}/pricing`} exact>
                  <>
                    <Helmet>
                      <link rel="canonical" href={`https://hackle.io/${lang}/pricing`} />
                      <link rel="alternate" href="https://hackle.io/ko/pricing" hrefLang="ko" />
                      <link rel="alternate" href="https://hackle.io/en/pricing" hrefLang="en" />
                      <link rel="alternate" href="https://hackle.io/en/pricing" hrefLang="x-default" />
                    </Helmet>
                    <Pricing />
                  </>
                </Route>
                <Route path={`${match.path}/service/feature-flags`} component={FeatureFlag} exact>
                  <>
                    <Helmet>
                      <link rel="canonical" href={`https://hackle.io/${lang}/feature-flags`} />
                      <link rel="alternate" href="https://hackle.io/ko/feature-flags" hrefLang="ko" />
                      <link rel="alternate" href="https://hackle.io/en/feature-flags" hrefLang="en" />
                      <link rel="alternate" href="https://hackle.io/en/feature-flags" hrefLang="x-default" />
                    </Helmet>
                    <FeatureFlag />
                  </>
                </Route>
                <Route path={`${match.path}/service/analytics`} exact>
                  <>
                    <Helmet>
                      <link rel="canonical" href={`https://hackle.io/${lang}/service/analytics`} />
                      <link rel="alternate" href="https://hackle.io/ko/service/analytics" hrefLang="ko" />
                      <link rel="alternate" href="https://hackle.io/en/service/analytics" hrefLang="en" />
                      <link rel="alternate" href="https://hackle.io/en/service/analytics" hrefLang="x-default" />
                    </Helmet>
                    <Analytics />
                  </>
                </Route>
                <Route path="*" component={NotFound} />
              </Switch>
            </MainFrame>
          )
        }}></Route>
      <Route path="*" component={NotFound} />
    </Switch>
  </Router>
)

export default function App() {
  return (
    <IntlProvider locale={locale} messages={messages}>
      <Meta />
      <Routes />
    </IntlProvider>
  )
}
